import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute, NavigationStart, Event } from "@angular/router";


import { SettingsCustomFormsService, SettingsCustomFormsEditorService } from '@app/services/settings/custom-forms.service';
import { AppService } from '@app/services/app/app.service';
import { TitleService } from '@core/services/title.service';

import { Form } from '@core/objects/form';
import { EditingForm, FormsStart } from '@app/store/state/settings/custom-forms/custom-forms.state';

@Component({
    selector: 'settings-forms-main-edit',
    templateUrl: './main-edit.component.html',
    styleUrls: ['./main-edit.component.scss']
})
export class SettingsFormsMainEditComponent implements OnInit, OnDestroy {
    private readonly ACCESS = 'access_setting_custom_forms';

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    public readonly VIEW_MODAL_NONE = 0;
    public readonly VIEW_MODAL_ERROR = 1;
    public readonly VIEW_MODAL_FORBIDDEN = 2;
    public readonly VIEW_MODAL_DATA_ERROR = 3;
    public readonly VIEW_MODAL_FIELD_OVERWRITE_WARNING = 4;
    

    public formId: string;
    public editingForm: EditingForm;
	public access: boolean = true;
    public status: number = this.STATUS_LOADING;
    public modalView: number = this.VIEW_MODAL_NONE;
    public leavingModal: boolean = false;
    public urlTo: string = '';
    public changesPending: boolean;
    public allowLeave: boolean = false;
    public secondEdit: boolean = false;

    public debugFormPreview: boolean = false;

    public breadcrumbs: any = [
        {
            title: "System Settings",
            link: ['/settings']
        },
        {
            title: "Forms",
            link: ['/settings/forms']
        }
    ];
    public titleText: string = "Add New Form"; //header title of the page
    public startingStatus: FormsStart;
    protected sessionSubscriptor: Subscription;
    protected editingSubscriptor: Subscription;
    protected errorSubscriptor: Subscription;
    protected errorFieldsSubscriptor: Subscription;
    protected formsInitializedSubscriptor: Subscription;
    protected navigationSubscriber: Subscription;

	constructor(
        public app: AppService,
        public formsSrv: SettingsCustomFormsService, 
        public formsEditorSrv: SettingsCustomFormsEditorService,
        private title: TitleService,
        private activeRoute: ActivatedRoute,
        private router: Router){}

    @HostListener('window:beforeunload', ['$event'])
    onFormEditLeave(event: any): void {
        if(this.changesPending){
            event.preventDefault(); 
            event.returnValue = false;
        }
    }

	ngOnInit(){
        this.title.set("Add new Form - Forms - System settings");
        // this.formsSrv.loadForms();

        this.formsInitializedSubscriptor = this.formsSrv.selectStarting().subscribe((starting: FormsStart) => {
            this.startingStatus = starting;
            // TODO: review and maybe not load forms when is add
            if(!this.startingStatus.initialized_forms){
                this.formsSrv.loadForms();
            } else {
                 if(this.activeRoute.snapshot.paramMap.has('id')) {
                    this.formId = this.activeRoute.snapshot.paramMap.get('id');
                    this.formsSrv.loadForm(this.formId);
                    if(!this.startingStatus.initialized_fields){
                        this.formsSrv.loadFields(this.formId);
                    }
                    this.title.set("Edit - Forms - System settings");
                    this.titleText = "Editing: ... ";
                } 
            }
            this.initView();
        });

        this.sessionSubscriptor = this.app.getSession().subscribe( (session: any) => {
            this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
            if (this.access){
                // TODO if needed
            }
        });

        this.editingSubscriptor = this.formsEditorSrv.selectEditing().subscribe((currentForm: EditingForm) => {
            this.changesPending = currentForm.form?.changed || currentForm.modified;
            this.editingForm = currentForm;
            if(currentForm.starting_fields?.length > 0 ){
                    this.secondEdit = true;
            }
            if(currentForm.form?.id != null) {
                this.title.set("Edit: "+currentForm.form.name+" - Forms - System settings");
                this.titleText = "Editing: " + currentForm.form.name;
            }
            this.initView();
        });

        this.errorSubscriptor = this.formsSrv.selectError('save_form').subscribe((error: HttpErrorResponse) => {
            this.setError(error)
        });

        this.errorFieldsSubscriptor = this.formsSrv.selectError('save_fields').subscribe((error: HttpErrorResponse) => {
            this.setError(error)
        });

        // router control for leaving
        this.navigationSubscriber = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                if(this.router.url != event.url){
                    // console.debug(" new route is out --->",this.router.url, event.url);
                    this.leavingModal = true;
                    this.urlTo = event.url;
                }
            }
        });   


	}

    ngOnDestroy() {
        this.leavingModal = false;
        this.editingSubscriptor.unsubscribe();
        this.sessionSubscriptor.unsubscribe();
        this.errorSubscriptor.unsubscribe();
        this.errorFieldsSubscriptor.unsubscribe();
        this.formsInitializedSubscriptor.unsubscribe();
        this.navigationSubscriber.unsubscribe();
        this.modalView = this.VIEW_MODAL_NONE;
        this.formsEditorSrv.clear();
    }

    initView(): void {
        // check when new form (url /add)
        if(!this.formId && this.startingStatus.initialized_forms && this.editingForm  ){
            this.status = this.STATUS_DONE;
            return;
        }
        // check when editing form
        if(!this.formId || !this.startingStatus.initialized_fields || !this.startingStatus.initialized_forms ||  !this.editingForm  ){
            return;
        }
        this.status = this.STATUS_DONE;
    }

    cancel(event){
        this.formsEditorSrv.clear();
        this.router.navigate(['/settings/forms']);
    }

    onPreSubmit(form: Form){
        if(this.secondEdit)
            this.modalView = this.VIEW_MODAL_FIELD_OVERWRITE_WARNING;
        else{ 
           this.onSubmit();
        }

    }

    onOverwriteDismiss(){
        this.modalView = this.VIEW_MODAL_NONE;
    }

    onSubmit(){
        this.formsSrv.saveForm(this.editingForm.form);
        this.secondEdit = true;
        this.modalView = this.VIEW_MODAL_NONE;
    }



    onDiscard(){
        this.leavingModal = false;
        this.allowLeave = true;
        this.router.navigateByUrl(this.urlTo);
    }

    onStay(){
        this.leavingModal =false;
        this.allowLeave = false;

    }

    protected setError(error: HttpErrorResponse) {
        // console.log("we have errors ",error)
        if(error == null)
            return;
        switch(error.status) {
            case 500:
            case 404:
                this.modalView = this.VIEW_MODAL_ERROR;
                break;
            case 406:
                this.modalView = this.VIEW_MODAL_DATA_ERROR;
                break;
            case 403:
                // this.viewVersionsSrv.clear();
                this.modalView = this.VIEW_MODAL_FORBIDDEN;
                break;
        }
    }

    onError(){
        this.modalView = this.VIEW_MODAL_NONE;
    }
}
